var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceNow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.094 0.684812C7.32694 0.636612 0.0755119 7.80771 0.000534058 16.6122C-0.0369548 21.2716 1.90176 25.4757 5.02405 28.4373C6.15942 29.5138 7.91605 29.6155 9.14783 28.6569C10.9687 27.2377 13.3091 26.3861 15.9976 26.3861C18.6861 26.3861 21.0265 27.2323 22.8473 28.6569C24.0898 29.6262 25.8518 29.5031 26.9979 28.4159C30.0773 25.4864 32 21.3466 32 16.7515C32 7.91482 24.8825 0.74372 16.094 0.690164M16.0029 24.7795C11.2526 24.7795 8.00174 21.202 8.00174 16.7783C8.00174 12.3546 11.2526 8.71815 16.0029 8.71815C20.7533 8.71815 24.0041 12.3546 24.0041 16.7783C24.0041 21.202 20.7533 24.7795 16.0029 24.7795Z",
    fill: "#8DC63F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceNow);
export default __webpack_public_path__ + "static/media/Service_now.45b6571bc6ba311ec8348fcfaf70ac68.svg";
export { ForwardRef as ReactComponent };